var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vue-loader/lib/selector?type=script&index=0!./DataViewLayoutOptions.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-06c58179\"}!../../vue-loader/lib/selector?type=template&index=0!./DataViewLayoutOptions.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/primevue/dataviewlayoutoptions/DataViewLayoutOptions.vue
// module id = 1969
// module chunks = 0